/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Saved_Addresses_HelpInputs */

const en_orders_saved_addresses_help = /** @type {(inputs: Orders_Saved_Addresses_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved addresses are sourced from the customer profile. Manual entry will be saved as the new default.`)
};

const es_orders_saved_addresses_help = /** @type {(inputs: Orders_Saved_Addresses_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las direcciones guardadas vienen del perfil del cliente. La captura manual se guardara como la nueva predeterminada.`)
};

/**
* | output |
* | --- |
* | "Saved addresses are sourced from the customer profile. Manual entry will be saved as the new default." |
*
* @param {Orders_Saved_Addresses_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_saved_addresses_help = /** @type {((inputs?: Orders_Saved_Addresses_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Saved_Addresses_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_saved_addresses_help(inputs)
	return es_orders_saved_addresses_help(inputs)
});